import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { getCollection } from '../actions/index';
import cookie from 'react-cookies';
import './App.css';
import Header from './header/Header';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showCookies: cookie.load('skip_cookies') ? cookie.load('skip_cookies') : ""
    };

    this.hideCookiesMessage = this.hideCookiesMessage.bind(this);
  }

  hideCookiesMessage() {
    cookie.save('skip_cookies', "1", { path: '/' });
    this.setState({
      showCookies: cookie.load('skip_cookies')
    })
  }

  render() {
    const { showCookies } = this.state;

    return (
      <div id="page-wrapper">
        <Header clickMenu={this.clickMenu} />
        {this.props.children}
        {showCookies !== '1' &&
          <div className="cookies-msg">
            ATENÇÃO! Este site utiliza cookies. Ao navegar no site estará a consentir a sua utilização.
          <Link to="/cookies">Saiba mais sobre o uso de cookies.</Link>
            <button onClick={this.hideCookiesMessage}>Fechar</button>
          </div>
        }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { collection: state.collection.collection };
}

export default connect(mapStateToProps, { getCollection })(App);




// WEBPACK FOOTER //
// ./src/components/App.js